export default class Utils {
  constructor() {}

  static loadJSON(url) {
    return fetch(url)
      .then((data) => data.text()).then(
        (txt)=>{
          return JSON.parse(txt);
        }
      )
      .then((json) => json);
  }
}